/* PARFUMPROBEN VERSAND – Produktkarte (snippets/card-product.liquid): Namen pro Reihe ausrichten.
   Global in layout/theme.liquid geladen; erfasst per MutationObserver auch nachgeladene Karten. */
/* Bricht in einer Reihe ein Produktname in die zweite Zeile um, bekommen alle Karten dieser Reihe zwei Zeilen Platz –
   sonst keine Leerzeile zwischen Name und Preis. */
(() => {
  if (window.__PPV_CARD_ROWS__) return;
  window.__PPV_CARD_ROWS__ = true;

  const range = document.createRange();
  const lineCount = name => {
    range.selectNodeContents(name);
    return new Set([...range.getClientRects()].map(rect => Math.round(rect.top))).size;
  };

  function align() {
    const rows = new Map();
    document.querySelectorAll('.ppv-card').forEach(card => {
      const name = card.querySelector('.ppv-card__name');
      if (!name || !card.offsetParent) return;
      /* offsetTop statt getBoundingClientRect: unabhängig von den Einblend-Animationen der Kacheln */
      const item = card.closest('.grid__item') || card;
      const key = `${item.offsetTop}|${card.closest('.grid, ul')?.id || ''}`;
      const row = rows.get(key) || { cards: [], two: false };
      row.cards.push(card);
      if (lineCount(name) > 1) row.two = true;
      rows.set(key, row);
    });
    rows.forEach(row => row.cards.forEach(card => card.classList.toggle('ppv-card--two-lines', row.two)));
  }

  let frame = 0;
  const schedule = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      align();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', align);
  else align();
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  document.fonts?.ready.then(schedule);
  new MutationObserver(mutations => {
    if (mutations.some(mutation => [...mutation.addedNodes].some(node => node.nodeType === 1 && (node.matches('.ppv-card, .grid__item') || node.querySelector?.('.ppv-card'))))) schedule();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
